import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * The row a notification or link points at: `?id=<uuid>` (or another param) on a list page.
 *
 * A page shows only that row while `focusId` is set, plus a `FocusedRowChip` to clear it. `clear`
 * drops just this param, so other filters in the URL (e.g. `storeId`) stay.
 */
export const useFocusedRow = (param = 'id') => {
    const [searchParams, setSearchParams] = useSearchParams();
    const focusId = searchParams.get(param);
    const clear = useCallback(() => {
        setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            next.delete(param);
            return next;
        }, { replace: true });
    }, [param, setSearchParams]);
    return { focusId, clear };
};

export default useFocusedRow;
